export default "__VITE_ASSET__1Vw3XSxm__"